import OffsecBiasView from './OffsecBiasView';

export default OffsecBiasView;
